
import { defineComponent } from 'vue';
import { CopyDocument } from '@element-plus/icons-vue'

export default defineComponent({
    name: 'copy',
    props: {
        text: {
            type: String,
            default: ''
        }
    },
    setup() {
        return {
            CopyDocument
        }
    }
});
